
const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/34932932913?text=Hola,%20quiero%20vender%20mi%20coche%20en%20Gavá"
      target="_blank"
      rel="nofollow noopener noreferrer"
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 bg-green-500 hover:bg-green-600 text-white w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:scale-110 cursor-pointer"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-fill text-2xl sm:text-3xl"></i>
    </a>
  );
};

export default WhatsAppFloat;
